// SuperAdminLayout.tsx
import React, { useEffect, useState } from "react";
import Sidebar from "../components/Admin-Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import InactiveShipmentAlertModal from "../components/InactiveShipmentAlertModal";
import "../components/Sidebar.css";

const SuperAdminLayout = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const getMobileTitle = () => {
    if (location.pathname.includes("/superAdmin/super-dashboard")) return "Super Dashboard";
    if (location.pathname.includes("/superAdmin/employee-directory")) return "Employee Directory";
    if (location.pathname.includes("/superAdmin/audit-logs")) return "Audit Logs";
    if (location.pathname.includes("/superAdmin/requestor-approval")) return "Requestor Approval";
    if (location.pathname.includes("/superAdmin/analytics")) return "Analytics";
    if (location.pathname.includes("/superAdmin/jo-ledger")) return "JO Ledger";
    if (location.pathname.includes("/superAdmin/jo-requests")) return "JO Requests";
    if (location.pathname.includes("/superAdmin/shipment-management")) return "Shipment Management";
    if (location.pathname.includes("/superAdmin/create-shipment")) return "Create Shipment";
    if (location.pathname.includes("/superAdmin/profile")) return "My Profile";
    return "Super Admin";
  };

  // Jump to top instantly when route changes (page navigation)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]); // Trigger when the route path changes

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen w-full bg-gray-100">
      <header className="sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-white/10 bg-blue px-4 py-3 text-white shadow-lg lg:hidden">
        <button
          type="button"
          onClick={() => setMobileMenuOpen(true)}
          className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10 text-white transition hover:bg-white/20"
          aria-label="Open menu"
        >
          <i className="fa-solid fa-bars text-lg" />
        </button>
        <div className="min-w-0 text-center">
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-white/70">
            Super Admin Portal
          </p>
          <p className="truncate text-sm font-bold">{getMobileTitle()}</p>
        </div>
        <div className="h-10 w-10" />
      </header>

      <aside className="fixed inset-y-0 left-0 z-30 hidden w-72 overflow-y-scroll sidebar-scrollable lg:block">
        <Sidebar />
      </aside>

      {mobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <button
            type="button"
            className="absolute inset-0 bg-black/40 backdrop-blur-[1px]"
            aria-label="Close menu"
            onClick={() => setMobileMenuOpen(false)}
          />
          <aside className="absolute inset-y-0 left-0 w-72 overflow-y-scroll sidebar-scrollable shadow-2xl">
            <Sidebar forceExpanded />
          </aside>
        </div>
      )}

      <div className="min-h-screen w-full lg:pl-72">
        <main className="w-full min-w-0 bg-gray-100">
          <div className="w-full px-4 py-4 sm:px-5 lg:px-6 lg:py-6">
            <Outlet />
          </div>
        </main>
      </div>
      <InactiveShipmentAlertModal />
    </div>
  );
};

export default SuperAdminLayout;
